import React from "react";

import "./ManagerContent.css";

const ManagerContent = ({ children }: { children: React.ReactNode }) => (
  <div className="manager-content">{children}</div>
);

export default ManagerContent;
